import { styled } from '@glitz/react';

export enum AspectRatio {
  '1:1' = 1,
  '2.39:1' = 1 / 2.39,
  '2:3' = 3 / 2,
  '3:2' = 2 / 3,
  '4:3' = 3 / 4,
  '3:4' = 4 / 3,
  '4:5' = 5 / 4,
  '6:3' = 3 / 6,
  '9:5' = 5 / 9,
  '9:16' = 16 / 9,
  '16:9' = 9 / 16,
  '17:6' = 6 / 17,
}

export function createAspectRatioDecorator(ratio: AspectRatio) {
  return styled({
    position: 'relative',
    overflow: 'hidden',
    paddingTop: `${ratio * 100}%`,
  });
}

export function createImageAspectRatioDecorator(image: Excite.ContentApi.ImageApiModel) {
  return styled({ aspectRatio: `${image.width} / ${image.height}` });
}
